import AssessmentTypesComponent from '@/components/Grid/Renderers/AssessmentTypesComponent';

export const propertyGridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const propertyGridColumns = [
  {
    headerName: 'UPRN',
    field: 'uprn',
    width: 200,
    minWidth: 200,
    filter: 'agSetColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    sort: 'asc',
  }, {
    headerName: 'Parent UPRN',
    field: 'parentUprn',
    minWidth: 140,
    width: 140,
  },  {
    headerName: 'Hierarchy Level',
    field: 'propertyHierarchyType',
    minWidth: 140,
    width: 140,
  },
  {
    headerName: 'Number Range',
    field: 'numberRange',
    width: 130,
    minWidth: 130,
  },
  {
    headerName: 'Building Name',
    field: 'buildingName',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Unit Number',
    field: 'unitNumber',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Street Name',
    field: 'street',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Street Number',
    field: 'streetNumber',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Town',
    field: 'town',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Postcode',
    field: 'postcode',
    filter: 'agTextColumnFilter',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Property Status',
    field: 'status',
    width: 140,
    minWidth: 140,
  },
  {
    headerName: 'Tenure',
    field: 'tenure',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Riskhub Designation',
    field: 'propertyDesignation',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Assessments to-do',
    field: 'assessmentsToDo',
    width: 220,
    minWidth: 220,
    cellRendererFramework: AssessmentTypesComponent,
    filterParams: {
      valueGetter: function getter(params) {
        return params.data.filterOptions;
      },
    },
  },
];
